import request from "./httpService";
const VALID_DATA_ENDPOINT = '/validdata'
const VALIDSERVICES_API_ENDPOINT = `${VALID_DATA_ENDPOINT}/validservice`;
const VALIDENCOUNTER_API_ENDPOINT = `${VALID_DATA_ENDPOINT}/validencounter`;
const VALIDTREATMENT_API_ENDPOINT = `${VALID_DATA_ENDPOINT}/validtreatment`;
const LENSBRAND_API_ENDPOINT = `${VALID_DATA_ENDPOINT}//validlensbrand`;
const LENSMODEL_API_ENDPOINT = '/validlensmodel';
const FRAMEBRAND_API_ENDPOINT = `${VALID_DATA_ENDPOINT}//validframebrand`;
const FRAMEMODEL_API_ENDPOINT = '/validframemodel';
const VALIDSUPPLIER_API_ENDPOINT = `${VALID_DATA_ENDPOINT}/validsupplier`;
// const VALIDFRAME_API_ENDPOINT = `${VALID_DATA_ENDPOINT}/validframe`;
const VALIDLAB_API_ENDPOINT = `${VALID_DATA_ENDPOINT}/validlab`;
const VALIDMANUFACTURER_API_ENDPOINT = `${VALID_DATA_ENDPOINT}/validmanufacturer`;
const INVENTORY_API_ENDPOINT = `${VALID_DATA_ENDPOINT}/inventory`;
const VALIDROLE_API_ENDPOINT = `${VALID_DATA_ENDPOINT}/validrole`;
const ROLEPERMISSION_API_ENDPOINT = `${VALID_DATA_ENDPOINT}/rolepermission`;
const ROLEPERMISSION_ACTION_API_ENDPOINT = `${VALID_DATA_ENDPOINT}/rolepermissionaction`;

/////////////////////////////////////////////////////////////////////
//  Encountern Services
/////////////////////////////////////////////////////////////////////
const getValidEncounterData = () => {
    return request({
        method: "GET",
        url: `${VALIDENCOUNTER_API_ENDPOINT}`
    });
}

const getValidEncounterDataWithLimit = (from, to, filters, sortBy, signal) => {
    return request({
        method: "GET",
        url: `${VALIDENCOUNTER_API_ENDPOINT}/withlimit/${from}/${to}`,
        params: {filters: filters, sortBy: sortBy},
        signal: signal
    });
}

const addValidEncounter = (data) => {
    return request({
        method: "POST",
        url: `${VALIDENCOUNTER_API_ENDPOINT}/new`,
        data: data,
    });
};

const deleteValidEncounter = (rowids) => {
    return request({
        method: "DELETE",
        url: `${VALIDENCOUNTER_API_ENDPOINT}`,
        params: {rowid: rowids}
    });
};

/////////////////////////////////////////////////////////////////////
//  Treatments
/////////////////////////////////////////////////////////////////////
const addValidTreatment = (data) => {
    return request({
        method: "POST",
        url: `${VALIDTREATMENT_API_ENDPOINT}/new`,
        data: data,
    });
};

const getValidTreatmentData = () => {
    return request({
        method: "GET",
        url: `${VALIDTREATMENT_API_ENDPOINT}`
    });
}

const getValidTreatmentDataWithLimit = (from, to, filters, sortBy, signal) => {
    return request({
        method: "GET",
        url: `${VALIDTREATMENT_API_ENDPOINT}/withlimit/${from}/${to}`,
        params: {filters: filters, sortBy: sortBy},
        signal: signal
    });
}

const deleteValidTreatment = (rowids) => {
    return request({
        method: "DELETE",
        url: `${VALIDTREATMENT_API_ENDPOINT}`,
        params: {rowid: rowids}
    });
};

/////////////////////////////////////////////////////////////////////
//  Order Services
/////////////////////////////////////////////////////////////////////
const addValidServices = (data) => {
    return request({
        method: "POST",
        url: `${VALIDSERVICES_API_ENDPOINT}/new`,
        data: data,
    });
};

const getOrderServicesData = () => {
    return request({
        method: "GET",
        url: `${VALIDSERVICES_API_ENDPOINT}`
    });
}

const getOrderServicesById = (id) => {
    return request({
        method: "GET",
        url: `${VALIDSERVICES_API_ENDPOINT}/${id}`
    });
}

const getOrderServicesWithLimit = (from, to, filters, sortBy, signal) => {
    return request({
        method: "GET",
        url: `${VALIDSERVICES_API_ENDPOINT}/withlimit/${from}/${to}`,
        params: {filters: filters, sortBy: sortBy},
        signal: signal
    });
}

const deleteOrderServicesRecord = (rowids) => {
    return request({
        method: "DELETE",
        url: `${VALIDSERVICES_API_ENDPOINT}`,
        params: {rowid: rowids}
    });
};

/////////////////////////////////////////////////////////////////////
//  Lens Brand
/////////////////////////////////////////////////////////////////////
const addLensBrand = (data) => {
    return request({
        method: "POST",
        url: `${LENSBRAND_API_ENDPOINT}/new`,
        data: data,
    });
};

const getLensBrandData = () => {
    return request({
        method: "GET",
        url: `${LENSBRAND_API_ENDPOINT}`
    });
}

const getLensBrandById = (id) => {
    return request({
        method: "GET",
        url: `${LENSBRAND_API_ENDPOINT}/${id}`
    });
}

const getLensBrandWithLimit = (from, to, token, sortBy, signal) => {
    return request({
        method: "GET",
        url: `${LENSBRAND_API_ENDPOINT}/withlimit/${from}/${to}`,
        params: {token: token, sortBy: sortBy},
        signal: signal
    });
}

const deleteLensBrandRecord = (rowids) => {
    return request({
        method: "DELETE",
        url: `${LENSBRAND_API_ENDPOINT}`,
        params: {rowid: rowids}
    });
};

/////////////////////////////////////////////////////////////////////
//  Lens Model
/////////////////////////////////////////////////////////////////////
const addLensModel = (data) => {
    return request({
        method: "POST",
        url: `${LENSMODEL_API_ENDPOINT}/new`,
        data: data,
    });
};

const getLensModelData = () => {
    return request({
        method: "GET",
        url: `${LENSMODEL_API_ENDPOINT}`
    });
}

const getLensModelById = (id) => {
    return request({
        method: "GET",
        url: `${LENSMODEL_API_ENDPOINT}/${id}`
    });
}

const getLensModelWithLimit = (from, to, token, sortBy, signal) => {
    return request({
        method: "GET",
        url: `${LENSMODEL_API_ENDPOINT}/withlimit/${from}/${to}`,
        params: {token: token, sortBy: sortBy},
        signal: signal
    });
}

const deleteLensModelRecord = (rowids) => {
    return request({
        method: "DELETE",
        url: `${LENSMODEL_API_ENDPOINT}`,
        params: {rowid: rowids}
    });
};

/////////////////////////////////////////////////////////////////////
//  Frame Model
/////////////////////////////////////////////////////////////////////
const addFrameModel = (data) => {
    return request({
        method: "POST",
        url: `${FRAMEMODEL_API_ENDPOINT}/new`,
        data: data,
    });
};

const getFrameModelData = () => {
    return request({
        method: "GET",
        url: `${FRAMEMODEL_API_ENDPOINT}`
    });
}

const getFrameModelById = (id) => {
    return request({
        method: "GET",
        url: `${FRAMEMODEL_API_ENDPOINT}/${id}`
    });
}

const getFrameModelWithLimit = (from, to, token, sortBy, signal) => {
    return request({
        method: "GET",
        url: `${FRAMEMODEL_API_ENDPOINT}/withlimit/${from}/${to}`,
        params: {token: token, sortBy: sortBy},
        signal: signal
    });
}

const deleteFrameModelRecord = (rowids) => {
    return request({
        method: "DELETE",
        url: `${FRAMEMODEL_API_ENDPOINT}`,
        params: {rowid: rowids}
    });
};

/////////////////////////////////////////////////////////////////////
//  Frame Brand
/////////////////////////////////////////////////////////////////////
const addFrameBrand = (data) => {
    return request({
        method: "POST",
        url: `${FRAMEBRAND_API_ENDPOINT}/new`,
        data: data,
    });
};

const getFrameBrandData = () => {
    return request({
        method: "GET",
        url: `${FRAMEBRAND_API_ENDPOINT}`
    });
}

const getFrameBrandById = (id) => {
    return request({
        method: "GET",
        url: `${FRAMEBRAND_API_ENDPOINT}/${id}`
    });
}

const getFrameBrandWithLimit = (from, to, token, sortBy, signal) => {
    return request({
        method: "GET",
        url: `${FRAMEBRAND_API_ENDPOINT}/withlimit/${from}/${to}`,
        params: {token: token, sortBy: sortBy},
        signal: signal
    });
}

const deleteFrameBrandRecord = (rowids) => {
    return request({
        method: "DELETE",
        url: `${FRAMEBRAND_API_ENDPOINT}`,
        params: {rowid: rowids}
    });
};

/////////////////////////////////////////////////////////////////////
//  Valid Supplier
/////////////////////////////////////////////////////////////////////
const addValidSupplier = (data) => {
    return request({
        method: "POST",
        url: `${VALIDSUPPLIER_API_ENDPOINT}/new`,
        data: data,
    });
}

const getValidSupplierrDataWithLimit = (from, to, filters, sortBy, type, signal) => {
    return request({
        method: "GET",
        url: `${VALIDSUPPLIER_API_ENDPOINT}/withlimit/${from}/${to}`,
        params: {filters: filters, sortBy: sortBy, supplierType: type},
        signal: signal
    });
}

const getBrandForSupplierWithLimit = (from, to, token, sortBy, supplierId, signal) => {
    return request({
        method: "GET",
        url: `${VALIDSUPPLIER_API_ENDPOINT}/brands/${supplierId}/withlimit/${from}/${to}`,
        params: {token: token, sortBy: sortBy},
        signal: signal
    });
}

const deleteValidSupplierRecord = (rowids) => {
    return request({
        method: "DELETE",
        url: `${VALIDSUPPLIER_API_ENDPOINT}`,
        params: {rowid: rowids}
    });
}

const deleteBrandFromSupplier = (rowids) => {
    return request({
        method: "DELETE",
        url: `${VALIDSUPPLIER_API_ENDPOINT}/brand`,
        params: {rowid: rowids}
    });
}

const updateValidSupplierRecord = (id, data) => {
    return request({
        method: "PUT",
        url: `${VALIDSUPPLIER_API_ENDPOINT}/${id}`,
        data: data
    });
}

/////////////////////////////////////////////////////////////////////
//  Valid Labs
/////////////////////////////////////////////////////////////////////
const addValidLab = (data) => {
    return request({
        method: "POST",
        url: `${VALIDLAB_API_ENDPOINT}/new`,
        data: data,
    });
};

const getValidLabDataWithLimit = (from, to, filters, sortBy, signal) => {
    return request({
        method: "GET",
        url: `${VALIDLAB_API_ENDPOINT}/withlimit/${from}/${to}`,
        params: {filters: filters, sortBy: sortBy},
        signal: signal
    });
};

const updateValidLab = (data) => {
    return request({
        method: "PUT",
        url: `${VALIDLAB_API_ENDPOINT}`,
        data: data,
    });
};

const deleteValidLab = (rowids) => {
    return request({
        method: "DELETE",
        url: `${VALIDLAB_API_ENDPOINT}`,
        params: {rowid: rowids}
    });
};

/////////////////////////////////////////////////////////////////////
//  Valid Manufacturers
/////////////////////////////////////////////////////////////////////
const addValidManufacturer = (data) => {
    return request({
        method: "POST",
        url: `${VALIDMANUFACTURER_API_ENDPOINT}/new`,
        data: data,
    });
};

const getValidManufacturerDataWithLimit = (from, to, filters, sortBy, signal) => {
    return request({
        method: "GET",
        url: `${VALIDMANUFACTURER_API_ENDPOINT}/withlimit/${from}/${to}`,
        params: {filters: filters, sortBy: sortBy},
        signal: signal
    });
};

const updateValidManufacturer = (data) => {
    return request({
        method: "PUT",
        url: `${VALIDMANUFACTURER_API_ENDPOINT}`,
        data: data,
    });
};

const deleteValidManufacturer = (rowids) => {
    return request({
        method: "DELETE",
        url: `${VALIDMANUFACTURER_API_ENDPOINT}`,
        params: {rowid: rowids}
    });
};

const addBrandToManufacturer = (manufacturerId, brandData) => {
    return request({
        method: "POST",
        url: `${VALIDMANUFACTURER_API_ENDPOINT}/brand/${manufacturerId}`,
        data: brandData,
    });
};

const getBrandsForManufacturer = (manufacturerId, from, to, signal) => {
    return request({
        method: "GET",
        url: `${VALIDMANUFACTURER_API_ENDPOINT}/brands/${manufacturerId}/withlimit/${from}/${to}`,
        signal: signal
    });
};

const deleteBrandFromManufacturer = (rowids) => {
    return request({
        method: "DELETE",
        url: `${VALIDMANUFACTURER_API_ENDPOINT}/brand`,
        params: {rowid: rowids}
    });
};

/////////////////////////////////////////////////////////////////////
//  Inventory
/////////////////////////////////////////////////////////////////////
const addInventory = (data) => {
    return request({
        method: "POST",
        url: `${INVENTORY_API_ENDPOINT}/new`,
        data: data,
    });
}

const updateInventory = (data) => {
    return request({
        method: "PUT",
        url: `${INVENTORY_API_ENDPOINT}`,
        data: data,
    });
}

const getInventoryDataWithLimit = (from, to, filters, sortBy, type, signal) => {
    return request({
        method: "GET",
        url: `${INVENTORY_API_ENDPOINT}/withlimit/${from}/${to}`,
        params: {filters: filters, sortBy: sortBy, type: type},
        signal: signal
    });
}

const deleteInventoryRecord = (rowids) => {
    return request({
        method: "DELETE",
        url: `${INVENTORY_API_ENDPOINT}`,
        params: {rowid: rowids}
    });
}

const updateInventoryRecord = (id, data) => {
    return request({
        method: "PUT",
        url: `${INVENTORY_API_ENDPOINT}/${id}`,
        data: data
    });
}

const getInventoryItemByField = (field, value, type) => {
    return request({
        method: "GET",
        url: `${INVENTORY_API_ENDPOINT}/item/${field}/${value}`,
        params: {type: type}
    });
}
/////////////////////////////////////////////////////////////////////
//  Data
/////////////////////////////////////////////////////////////////////
const getLensTypes = () => {
    return request({
        method: "GET",
        url: `${VALID_DATA_ENDPOINT}/lenstypes`
    });
}

const getLensMaterialTypes = () => {
    return request({
        method: "GET",
        url: `${VALID_DATA_ENDPOINT}/lensmaterial`
    });
}

const getContactLensTypes = () => {
    return request({
        method: "GET",
        url: `${VALID_DATA_ENDPOINT}/contactlenstypes`
    });
}

const getContactLensMaterial = () => {
    return request({
        method: "GET",
        url: `${VALID_DATA_ENDPOINT}/contactlensmaterial`
    });
}

const getContactLensWearSchedule = () => {
    return request({
        method: "GET",
        url: `${VALID_DATA_ENDPOINT}/contactlenswearschedule`
    });
}

const getInvoiceStatusTypes = () => {
    return request({
        method: "GET",
        url: `${VALID_DATA_ENDPOINT}/invoicestatus`
    });
}

const getValidPaymentMethods = () => {
    return request({
        method: "GET",
        url: `${VALID_DATA_ENDPOINT}/validpaymentmethod`
    });
}

const getInventoryLocationFilterOptions = (type) => {
    return request({
        method: "GET",
        url: `${INVENTORY_API_ENDPOINT}/locationfilter`,
        params: {type: type}
    });
}

const getValidBrandFilterOptions = (type) => {
    return request({
        method: "GET",
        url: `${INVENTORY_API_ENDPOINT}/brandfilter`,
        params: {type: type}
    });
}

const getValidSupplierFilterOptions = (type) => {
    return request({
        method: "GET",
        url: `${INVENTORY_API_ENDPOINT}/supplierfilter`,
        params: {type: type, property: 'supplier'}
    });
}

const getPropertyFilterOptions = (type, property) => {
        return request({
        method: "GET",
        url: `${INVENTORY_API_ENDPOINT}/propertyfilteroptions`,
        params: {type: type, property: property}
    });
}

const getAllBrands = (type, supplierId, signal) => {
    return request({
        method: "GET",
        url: `${INVENTORY_API_ENDPOINT}/brands`,
        params: {
            type: type,
            ...(supplierId && { supplierId })
        },
        signal
    });
}

const getManufacturers = (signal) => {
    return request({
        method: "GET",
        url: `${INVENTORY_API_ENDPOINT}/manufacturers`,
        signal
    });
}

const getManufacturersByType = (type, signal) => {
    return request({
        method: "GET",
        url: `${VALIDMANUFACTURER_API_ENDPOINT}/active/type/${type}`,
        signal
    });
}

const getManufacturersWithPricingByType = (type, signal) => {
    return request({
        method: "GET",
        url: `${VALIDMANUFACTURER_API_ENDPOINT}/active/type/${type}/with-pricing`,
        signal
    });
}

const getManufacturerBrands = (manufacturerId, type, signal) => {
    return request({
        method: "GET",
        url: `${INVENTORY_API_ENDPOINT}/manufacturer-brands/${manufacturerId}`,
        params: { type },
        signal
    });
}

/////////////////////////////////////////////////////////////////////
//  Filter Options (for inventory column filters)
/////////////////////////////////////////////////////////////////////
const getFrameMaterialsFilter = () => {
    return request({
        method: "GET",
        url: `${VALID_DATA_ENDPOINT}/filter-options/materials`
    });
}

const getFrameShapesFilter = () => {
    return request({
        method: "GET",
        url: `${VALID_DATA_ENDPOINT}/filter-options/shapes`
    });
}

const getInventoryBrandsFilter = () => {
    return request({
        method: "GET",
        url: `${VALID_DATA_ENDPOINT}/filter-options/brands`
    });
}

const getInventoryLocationsFilter = () => {
    return request({
        method: "GET",
        url: `${VALID_DATA_ENDPOINT}/filter-options/locations`
    });
}
/////////////////////////////////////////////////////////////////////
//  Suppliers and Brands
/////////////////////////////////////////////////////////////////////

/**
 * Get all suppliers for a specific type with tenant filtering
 * @param {string} type - Type of supplies ('accessories', 'frames', 'lenses', 'contacts')
 * @returns {Promise}
 */
const getAllSuppliers = (type = null) => {
    return request({
        method: "GET",
        url: `${VALID_DATA_ENDPOINT}/suppliers`,
        params: { type }
    });
};

/**
 * Get brands for a specific supplier with tenant filtering
 * @param {number} supplierId - Supplier ID
 * @returns {Promise}
 */
const getBrandsForSupplier = (supplierId) => {
    return request({
        method: "GET",
        url: `${VALID_DATA_ENDPOINT}/suppliers/${supplierId}/brands`
    });
};
export const ValidDataService = {
    addValidServices,
    getOrderServicesData,
    getOrderServicesById,
    getOrderServicesWithLimit,
    deleteOrderServicesRecord,
    addLensBrand,
    getLensBrandData,
    getLensBrandById,
    getLensBrandWithLimit,
    deleteLensBrandRecord,
    addLensModel,
    getLensModelData,
    getLensModelById,
    getLensModelWithLimit,
    deleteLensModelRecord,
    addFrameModel,
    getFrameModelData,
    getFrameModelById,
    getFrameModelWithLimit,
    deleteFrameModelRecord,
    addFrameBrand,
    getFrameBrandData,
    getFrameBrandById,
    getFrameBrandWithLimit,
    deleteFrameBrandRecord,
    addValidEncounter,
    deleteValidEncounter,
    getValidEncounterDataWithLimit,
    getValidEncounterData,
    addValidTreatment,
    getValidTreatmentData,
    getValidTreatmentDataWithLimit,
    deleteValidTreatment,
    addValidSupplier,
    updateValidSupplierRecord,
    getValidSupplierrDataWithLimit,
    getBrandForSupplierWithLimit,
    deleteValidSupplierRecord,
    deleteBrandFromSupplier,
    addValidLab,
    getValidLabDataWithLimit,
    updateValidLab,
    deleteValidLab,
    addValidManufacturer,
    getValidManufacturerDataWithLimit,
    updateValidManufacturer,
    deleteValidManufacturer,
    addBrandToManufacturer,
    getBrandsForManufacturer,
    deleteBrandFromManufacturer,
    addInventory,
    updateInventory,
    deleteInventoryRecord,
    getInventoryDataWithLimit,
    updateInventoryRecord,
    getInventoryItemByField,
    getLensTypes,
    getLensMaterialTypes,
    getContactLensTypes,
    getContactLensMaterial,
    getContactLensWearSchedule,
    getInvoiceStatusTypes,
    getValidPaymentMethods,
    getInventoryLocationFilterOptions,
    getValidBrandFilterOptions,
    getValidSupplierFilterOptions,
    getPropertyFilterOptions,
    getAllBrands,
    getManufacturers,
    getManufacturersByType,
    getManufacturersWithPricingByType,
    getManufacturerBrands,
    getFrameMaterialsFilter,
    getFrameShapesFilter,
    getInventoryBrandsFilter,
    getInventoryLocationsFilter,
    getAllSuppliers,
    getBrandsForSupplier
};

// Role management
export const ValidRoleService = {
    add: (data) => request({ method: 'POST', url: `${VALIDROLE_API_ENDPOINT}/new`, data }),
    update: (data) => request({ method: 'PUT', url: `${VALIDROLE_API_ENDPOINT}/`, data }),
    getAll: (signal) => request({ method: 'GET', url: `${VALIDROLE_API_ENDPOINT}`, signal }),
    getWithLimit: (from, to, filters, sortBy, signal) => request({ method: 'GET', url: `${VALIDROLE_API_ENDPOINT}/withlimit/${from}/${to}`, params: { filters, sortBy }, signal }),
    delete: (rowids) => request({ method: 'DELETE', url: `${VALIDROLE_API_ENDPOINT}`, params: { rowid: rowids } }),
};

// Role permissions management
export const RolePermissionService = {
    getForRole: (roleId, signal) => request({ method: 'GET', url: `${ROLEPERMISSION_API_ENDPOINT}/${roleId}`, signal }),
    upsertForRole: (roleId, permissions, stampUser) => request({ method: 'PUT', url: `${ROLEPERMISSION_API_ENDPOINT}/${roleId}`, data: { permissions, stampUser } }),
};

// Per-action permissions (e.g., invoice actions)
export const RolePermissionActionService = {
    getForRoleSection: (roleId, section) => request({ method: 'GET', url: `${ROLEPERMISSION_ACTION_API_ENDPOINT}/${roleId}/${section}` }),
    upsertForRoleSection: (roleId, section, actions, stampUser) => request({ method: 'PUT', url: `${ROLEPERMISSION_ACTION_API_ENDPOINT}/${roleId}/${section}`, data: { actions, stampUser } }),
    // Bulk operations for multiple sections at once
    getBulkForRole: (roleId, sections) => request({ method: 'POST', url: `${ROLEPERMISSION_ACTION_API_ENDPOINT}/${roleId}/bulk/get`, data: { sections } }),
    upsertBulkForRole: (roleId, sectionActions, stampUser) => request({ method: 'PUT', url: `${ROLEPERMISSION_ACTION_API_ENDPOINT}/${roleId}/bulk`, data: { sectionActions, stampUser } }),
};

/////////////////////////////////////////////////////////////////////
//  Lens Configuration Services
/////////////////////////////////////////////////////////////////////
const LENS_TREATMENTS_API_ENDPOINT = `${VALID_DATA_ENDPOINT}/lenstreatments`;
const LENS_MATERIALS_API_ENDPOINT = `${VALID_DATA_ENDPOINT}/lensmaterials`;
const LENS_INDEXES_API_ENDPOINT = `${VALID_DATA_ENDPOINT}/lensindexes`;
const LENS_MODELS_API_ENDPOINT = `${VALID_DATA_ENDPOINT}/lensmodels`;

// Lens Treatments
const getLensTreatmentsWithLimit = (from, to, filters, sortBy, signal) => {
    return request({
        method: "GET",
        url: `${LENS_TREATMENTS_API_ENDPOINT}/withlimit/${from}/${to}`,
        params: { filters, sortBy },
        signal
    });
};

const addLensTreatment = (data) => {
    return request({
        method: "POST",
        url: `${LENS_TREATMENTS_API_ENDPOINT}/new`,
        data
    });
};

const updateLensTreatment = (data) => {
    return request({
        method: "PUT",
        url: `${LENS_TREATMENTS_API_ENDPOINT}`,
        data
    });
};

const deleteLensTreatment = (rowids) => {
    return request({
        method: "DELETE",
        url: `${LENS_TREATMENTS_API_ENDPOINT}`,
        params: { rowid: rowids }
    });
};

// Lens Materials
const getLensMaterialsWithLimit = (from, to, filters, sortBy, signal) => {
    return request({
        method: "GET",
        url: `${LENS_MATERIALS_API_ENDPOINT}/withlimit/${from}/${to}`,
        params: { filters, sortBy },
        signal
    });
};

const addLensMaterial = (data) => {
    return request({
        method: "POST",
        url: `${LENS_MATERIALS_API_ENDPOINT}/new`,
        data
    });
};

const updateLensMaterial = (data) => {
    return request({
        method: "PUT",
        url: `${LENS_MATERIALS_API_ENDPOINT}`,
        data
    });
};

const deleteLensMaterial = (rowids) => {
    return request({
        method: "DELETE",
        url: `${LENS_MATERIALS_API_ENDPOINT}`,
        params: { rowid: rowids }
    });
};

// Lens Indexes
const getLensIndexesWithLimit = (from, to, filters, sortBy, signal) => {
    return request({
        method: "GET",
        url: `${LENS_INDEXES_API_ENDPOINT}/withlimit/${from}/${to}`,
        params: { filters, sortBy },
        signal
    });
};

const addLensIndex = (data) => {
    return request({
        method: "POST",
        url: `${LENS_INDEXES_API_ENDPOINT}/new`,
        data
    });
};

const updateLensIndex = (data) => {
    return request({
        method: "PUT",
        url: `${LENS_INDEXES_API_ENDPOINT}`,
        data
    });
};

const deleteLensIndex = (rowids) => {
    return request({
        method: "DELETE",
        url: `${LENS_INDEXES_API_ENDPOINT}`,
        params: { rowid: rowids }
    });
};

// Lens Models
const getLensConfigModelsWithLimit = (from, to, filters, sortBy, signal) => {
    return request({
        method: "GET",
        url: `${LENS_MODELS_API_ENDPOINT}/withlimit/${from}/${to}`,
        params: { filters, sortBy },
        signal
    });
};

const getLensConfigModelsByManufacturer = (manufacturerId, signal) => {
    return request({
        method: "GET",
        url: `${LENS_MODELS_API_ENDPOINT}/manufacturer/${manufacturerId}`,
        signal
    });
};

const addLensConfigModel = (data) => {
    return request({
        method: "POST",
        url: `${LENS_MODELS_API_ENDPOINT}/new`,
        data
    });
};

const updateLensConfigModel = (data) => {
    return request({
        method: "PUT",
        url: `${LENS_MODELS_API_ENDPOINT}`,
        data
    });
};

const deleteLensConfigModel = (rowids) => {
    return request({
        method: "DELETE",
        url: `${LENS_MODELS_API_ENDPOINT}`,
        params: { rowid: rowids }
    });
};

// Lens Pricing Matrix
const LENS_PRICING_MATRIX_API_ENDPOINT = `${VALID_DATA_ENDPOINT}/lenspricingmatrix`;

const getLensPricingMatrixWithLimit = (from, to, filters, sortBy, signal) => {
    return request({
        method: "GET",
        url: `${LENS_PRICING_MATRIX_API_ENDPOINT}/withlimit/${from}/${to}`,
        params: { filters, sortBy },
        signal
    });
};

const getLensPricing = (lensModelId, lensMaterialId, lensIndexId, treatmentIds, signal) => {
    return request({
        method: "POST",
        url: `${LENS_PRICING_MATRIX_API_ENDPOINT}/getpricing`,
        data: { lensModelId, lensMaterialId, lensIndexId, treatmentIds },
        signal
    });
};

const addLensPricingMatrix = (data) => {
    return request({
        method: "POST",
        url: `${LENS_PRICING_MATRIX_API_ENDPOINT}/new`,
        data
    });
};

const updateLensPricingMatrix = (data) => {
    return request({
        method: "PUT",
        url: `${LENS_PRICING_MATRIX_API_ENDPOINT}`,
        data
    });
};

const deleteLensPricingMatrix = (rowids) => {
    return request({
        method: "DELETE",
        url: `${LENS_PRICING_MATRIX_API_ENDPOINT}`,
        data: { ids: rowids }
    });
};

/////////////////////////////////////////////////////////////////////
//  Contact Lens Configuration Services
/////////////////////////////////////////////////////////////////////
const CONTACT_LENS_API_ENDPOINT = `${VALID_DATA_ENDPOINT}/contactlens`;

// Contact Lens Schedules
const getContactLensSchedulesWithLimit = (from, to, filters, sortBy, signal) => {
    return request({
        method: "GET",
        url: `${CONTACT_LENS_API_ENDPOINT}/schedules/${from}/${to}`,
        params: { filters, sortBy },
        signal
    });
};

const getActiveContactLensSchedules = (signal) => {
    return request({
        method: "GET",
        url: `${CONTACT_LENS_API_ENDPOINT}/schedules/active`,
        signal
    });
};

const addContactLensSchedule = (data) => {
    return request({
        method: "POST",
        url: `${CONTACT_LENS_API_ENDPOINT}/schedules`,
        data
    });
};

const updateContactLensSchedule = (data) => {
    return request({
        method: "PUT",
        url: `${CONTACT_LENS_API_ENDPOINT}/schedules`,
        data
    });
};

const deleteContactLensSchedule = (rowids) => {
    return request({
        method: "DELETE",
        url: `${CONTACT_LENS_API_ENDPOINT}/schedules`,
        data: { ids: rowids }
    });
};

// Contact Lens Materials
const getContactLensMaterialsWithLimit = (from, to, filters, sortBy, signal) => {
    return request({
        method: "GET",
        url: `${CONTACT_LENS_API_ENDPOINT}/materials/${from}/${to}`,
        params: { filters, sortBy },
        signal
    });
};

const getActiveContactLensMaterials = (signal) => {
    return request({
        method: "GET",
        url: `${CONTACT_LENS_API_ENDPOINT}/materials/active`,
        signal
    });
};

const addContactLensMaterial = (data) => {
    return request({
        method: "POST",
        url: `${CONTACT_LENS_API_ENDPOINT}/materials`,
        data
    });
};

const updateContactLensMaterial = (data) => {
    return request({
        method: "PUT",
        url: `${CONTACT_LENS_API_ENDPOINT}/materials`,
        data
    });
};

const deleteContactLensMaterial = (rowids) => {
    return request({
        method: "DELETE",
        url: `${CONTACT_LENS_API_ENDPOINT}/materials`,
        data: { ids: rowids }
    });
};

// Contact Lens Models
const getContactLensModelsWithLimit = (from, to, filters, sortBy, signal) => {
    return request({
        method: "GET",
        url: `${CONTACT_LENS_API_ENDPOINT}/models/withlimit/${from}/${to}`,
        params: { filters, sortBy },
        signal
    });
};

const getActiveContactLensModels = (signal) => {
    return request({
        method: "GET",
        url: `${CONTACT_LENS_API_ENDPOINT}/models/active`,
        signal
    });
};

const addContactLensModel = (data) => {
    return request({
        method: "POST",
        url: `${CONTACT_LENS_API_ENDPOINT}/models`,
        data
    });
};

const updateContactLensModel = (data) => {
    return request({
        method: "PUT",
        url: `${CONTACT_LENS_API_ENDPOINT}/models`,
        data
    });
};

const deleteContactLensModel = (rowids) => {
    return request({
        method: "DELETE",
        url: `${CONTACT_LENS_API_ENDPOINT}/models`,
        data: { ids: rowids }
    });
};

// Contact Lens Pricing Matrix
const getContactLensPricingMatrixWithLimit = (from, to, filters, sortBy, signal) => {
    return request({
        method: "GET",
        url: `${CONTACT_LENS_API_ENDPOINT}/pricing/${from}/${to}`,
        params: { filters, sortBy },
        signal
    });
};

const addContactLensPricingMatrix = (data) => {
    return request({
        method: "POST",
        url: `${CONTACT_LENS_API_ENDPOINT}/pricing`,
        data
    });
};

const updateContactLensPricingMatrix = (data) => {
    return request({
        method: "PUT",
        url: `${CONTACT_LENS_API_ENDPOINT}/pricing`,
        data
    });
};

const deleteContactLensPricingMatrix = (rowids) => {
    return request({
        method: "DELETE",
        url: `${CONTACT_LENS_API_ENDPOINT}/pricing`,
        data: { ids: rowids }
    });
};

const getContactLensPricing = (contactLensModelId, scheduleId, boxQuantity, signal) => {
    return request({
        method: "GET",
        url: `${CONTACT_LENS_API_ENDPOINT}/pricing/calculate`,
        params: { contactLensModelId, scheduleId, boxQuantity },
        signal
    });
};

export const LensConfigurationService = {
    // Treatments
    getTreatmentsWithLimit: getLensTreatmentsWithLimit,
    addTreatment: addLensTreatment,
    updateTreatment: updateLensTreatment,
    deleteTreatment: deleteLensTreatment,
    
    // Materials
    getMaterialsWithLimit: getLensMaterialsWithLimit,
    addMaterial: addLensMaterial,
    updateMaterial: updateLensMaterial,
    deleteMaterial: deleteLensMaterial,
    
    // Indexes
    getIndexesWithLimit: getLensIndexesWithLimit,
    addIndex: addLensIndex,
    updateIndex: updateLensIndex,
    deleteIndex: deleteLensIndex,
    
    // Models
    getModelsWithLimit: getLensConfigModelsWithLimit,
    getModelsByManufacturer: getLensConfigModelsByManufacturer,
    addModel: addLensConfigModel,
    updateModel: updateLensConfigModel,
    deleteModel: deleteLensConfigModel,
    
    // Pricing Matrix
    getPricingMatrixWithLimit: getLensPricingMatrixWithLimit,
    getPricing: getLensPricing,
    addPricingMatrix: addLensPricingMatrix,
    updatePricingMatrix: updateLensPricingMatrix,
    deletePricingMatrix: deleteLensPricingMatrix,
};

export const ContactLensConfigurationService = {
    // Schedules
    getSchedulesWithLimit: getContactLensSchedulesWithLimit,
    getActiveSchedules: getActiveContactLensSchedules,
    addSchedule: addContactLensSchedule,
    updateSchedule: updateContactLensSchedule,
    deleteSchedule: deleteContactLensSchedule,
    
    // Materials
    getMaterialsWithLimit: getContactLensMaterialsWithLimit,
    getActiveMaterials: getActiveContactLensMaterials,
    addMaterial: addContactLensMaterial,
    updateMaterial: updateContactLensMaterial,
    deleteMaterial: deleteContactLensMaterial,
    
    // Models
    getModelsWithLimit: getContactLensModelsWithLimit,
    getActiveModels: getActiveContactLensModels,
    addModel: addContactLensModel,
    updateModel: updateContactLensModel,
    deleteModel: deleteContactLensModel,
    
    // Pricing Matrix
    getPricingMatrixWithLimit: getContactLensPricingMatrixWithLimit,
    addPricingMatrix: addContactLensPricingMatrix,
    updatePricingMatrix: updateContactLensPricingMatrix,
    deletePricingMatrix: deleteContactLensPricingMatrix,
    
    // Pricing Calculation
    getPricing: getContactLensPricing,
};

